import React, {useContext, useState, useEffect} from 'react'
import {
    Grid,
    Typography,
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    CircularProgress,
    Tooltip,
} from '@material-ui/core'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import MasterTab from '../../components/MasterTab'
import {MyAccountContext} from '../../containers/Layout'
import {ToastContext} from '../../../App'
import i18next from 'i18next'
import {TOAST_VARIANT} from '../../../utils/constants'
//import {tabSchema} from '../../utils/constants'
import {getClientProgramAPIData, getMyAccountAPIData} from '../../services/myaccount'
import {
    validateURL,
    redirectToProgramSignUp,
    redirectToProgramDashboard,
    redirectToProgramRegistration,
} from '../../../utils/utils'

const Program = props => {
    const {routeObject, myAccountSchema} = useContext(MyAccountContext)
    const schema = JSON.parse(
        JSON.stringify(myAccountSchema && myAccountSchema.tabSchema[routeObject.key])
    )

    const filteredTabs = schema.masterTabProp.filter(unit => {
        const routeTab = unit.router.toLowerCase()
        let toShow = props.data[routeTab] === undefined ? false : props.data[routeTab]
        if(!toShow && unit.extraCondition) {
            const extraCondition = unit.extraCondition.toLowerCase()
            toShow = props.data[extraCondition] === undefined ? false : props.data[extraCondition]
        }
        return toShow && unit
    })

    schema.masterTabProp = []
    schema.masterTabProp = filteredTabs

    const componentName =
        Array.isArray(schema.masterTabProp) && schema.masterTabProp.length > 0
            ? schema.masterTabProp[0].router
            : props.componentName
    let tabData = {isProgram: true, ...props}
    tabData.componentName = componentName

    return (
        <Grid container className="program-details__wrapper">
            <Grid item xs={12} className="program-dtls_wrapper">
                <ProgramHeader {...props} />
                <Grid container spacing={3} className="program-dtls_content__row">
                    <Grid item xs={12} className="program-dtls_content">
                        <MasterTab data={tabData} {...schema} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

const ProgramHeader = props => {
    const {clientObject, practiceObject, routeObject, resourceObject} = useContext(
        MyAccountContext
    )
    const {showToast} = useContext(ToastContext)
    const [isBtnClicked, setBtnStatus] = useState(false)
    const [disableManage, setdisableManage] = useState(false)
    const [isLaunchBtnClicked, setLaunchBtnStatus] = useState(false)
    const [open, setOpen] = useState(false)
    const [isSignup, setIsSignup] = useState(true)
    const [isLaunch, setIsLaunch] = useState(true)
    const [isEnrollAccess, setIsEnrollAccess] = useState(true)

    useEffect(() => {
        if (props.data && props.data.signup !== undefined && props.data.signup !== null) {
            //checking undefined and null as the value comes boolean
            // props.data.signup ? setdisableManage(false) : setdisableManage(true)
            setIsSignup(props.data.signup)
        }
        if (
            props.data &&
            props.data.dashboard !== undefined &&
            props.data.dashboard !== null
        )
            setIsLaunch(props.data.dashboard)
    }, [props])

    useEffect(() => {
        accessController()
    }, [])

    useEffect(() => {
        accessController()
    }, [resourceObject])

    const accessController = () => {
        if (resourceObject['isPolicyBased']) {
            if (
                resourceObject['resource'] &&
                resourceObject['resource'].resource === 'MyAccount Application' &&
                resourceObject['resource'].childs &&
                resourceObject['resource'].childs.length > 0
            ) {
                let enrollBtnAccess = resourceObject['resource'].childs.filter(
                    value => value.resource === 'Enroll'
                )

                if (enrollBtnAccess && enrollBtnAccess.length > 0) {
                    let action = enrollBtnAccess[0].actions
                    let actions = action.split(',')

                    actions.includes('View')
                        ? setIsEnrollAccess(true)
                        : setIsEnrollAccess(false)
                } else {
                    setIsEnrollAccess(false)
                }
            } else {
                setIsEnrollAccess(false)
            }
        }
    }

    const callSignUpApi = async () => {
        setdisableManage(true)
        const data = await getMyAccountAPIData(
            `clientprogram/manage/${clientObject.clientprogramid}`
        )
        if (data) {
            if (data.error && Object.keys(data.error).length > 0)
                showToast({
                    open: true,
                    variant: TOAST_VARIANT.ERROR,
                    message: `${clientObject.clientprogramname} ${i18next.t(
                        'myaccount.subscribed.manage.error'
                    )}`,
                })
            else if (Object.entries(data).length > 0)
                redirectToProgramSignUp(
                    data.url,
                    '',
                    clientObject.cliententityid,
                    clientObject.parentcliententityid
                )

            setdisableManage(false)
        }
    }

    const callDashboardApi = async () => {
        setLaunchBtnStatus(true)
        const data = await getMyAccountAPIData(
            `clientprogram/launch/${clientObject.clientprogramid}`
        )
        if (data) {
            if (data.error && Object.keys(data.error).length > 0)
                showToast({
                    open: true,
                    variant: TOAST_VARIANT.ERROR,
                    message: `${clientObject.clientprogramname} ${i18next.t(
                        'myaccount.subscribed.launch.error'
                    )}`,
                })
            else if (Object.entries(data).length > 0) redirectToProgramDashboard(data.url)

            setLaunchBtnStatus(false)
        }
    }

    const getProgramSignUpURL = () => {
        setBtnStatus(true)
        const callApi = async () => {
            const data = await getClientProgramAPIData(
                'user/cliententity/enrol',
                {},
                {
                    'client-entity-id': clientObject.cliententityid,
                    'client-program-id': clientObject.clientprogramid,
                }
            )

            if (data) {
                setBtnStatus(false)
                if (Object.entries(data).length > 0)
                    redirectToProgramRegistration(
                        data.registrationurl,
                        clientObject.parentcliententityid
                    )
                else
                    showToast({
                        open: true,
                        variant: TOAST_VARIANT.ERROR,
                        message: i18next.t('myaccount.available.enroll.error'),
                    })
            }
        }
        callApi()
    }

    const programAuthorizeEnrollment = () => {
        setBtnStatus(true)
        const callApi = async () => {
            const data = await getClientProgramAPIData(
                'cliententity/authorize/enrollment',
                {},
                {
                    'client-entity-id': clientObject.cliententityid,
                    'client-program-id': clientObject.clientprogramid,
                }
            )

            if (data) {
                setBtnStatus(false)
                if (Object.entries(data).length > 0) {
                    if (data.authorizeeverynewprogram) {
                        if (
                            data.hasOwnProperty('interestregistered') &&
                            data.interestregistered
                        )
                            setOpen(true)
                        //interest already registered in system show waiting for approval

                        if (data.hasOwnProperty('approved')) {
                            switch (data.approved) {
                                case true:
                                    getProgramSignUpURL()
                                    break

                                case false:
                                    showToast({
                                        open: true,
                                        variant: TOAST_VARIANT.ERROR,
                                        message:
                                            'Your request for registration has been declined by admin of ' +
                                            clientObject.clientprogramname,
                                    })
                                    break

                                case '':
                                case null:
                                    showToast({
                                        open: true,
                                        variant: TOAST_VARIANT.WARNING,
                                        message:
                                            'Your request is already sent to ' +
                                            clientObject.clientprogramname +
                                            ', once approved you can enroll for the program.',
                                    })
                                    break

                                default:
                                    break
                            }
                        }
                    } else getProgramSignUpURL()
                } else
                    showToast({
                        open: true,
                        variant: TOAST_VARIANT.ERROR,
                        message: i18next.t('myaccount.available.authorizeenroll.error'),
                    })
            }
        }
        if (clientObject && clientObject.mipsdateexpired) {
            showToast({
                open: true,
                variant: TOAST_VARIANT.WARNING,
                message: clientObject.mipsdateexpiredmessage
                    ? clientObject.mipsdateexpiredmessage
                    : i18next.t('myaccount.available.mipsdate.warning'),
            })
            setBtnStatus(false)
        } else {
            callApi()
        }
    }

    const handleClickEvent = target => {
        switch (target.toLowerCase()) {
            case 'enroll':
                programAuthorizeEnrollment()
                break
            case 'managed':
                callSignUpApi()
                break
            case 'launch':
                // redirectToProgramDashboard(routeObject.dashboard)
                callDashboardApi()
                break
            default:
                break
        }
    }

    const closeDialog = () => {
        setOpen(false)
        setBtnStatus(false)
    }

    return (
        <Grid container spacing={3} className="program-dtls_header">
            <Grid item xs={12} sm className="program-header__ttl">
                {props.setRouter && (
                    <>
                        <Typography
                            className="form-row--heading_h6"
                            variant="h6"
                            gutterBottom
                        >
                            <span
                                className="back-btn__span"
                                onClick={() =>
                                    props.setRouter(props.backRouter || 'dashboard')
                                }
                            >
                                <FontAwesomeIcon
                                    icon={['fal', 'angle-left']}
                                    //onClick={() => props.setRouter('dashboard')}
                                ></FontAwesomeIcon>
                            </span>
                            &nbsp;
                            {clientObject.clientprogramname}
                        </Typography>
                    </>
                )}
            </Grid>
            <Grid item className="program-header__practice-name__wrapper">
                <Grid xs className="program-header__practice-name">
                    <div className="practice__name">
                        {' '}
                        {practiceObject.practicename}
                        <span className="practice__id">
                            (
                            {(practiceObject.subscribedid &&
                                practiceObject.subscribedid) ||
                                practiceObject.practiceId}
                            )
                        </span>
                    </div>
                </Grid>
                <Grid item xs className="program-header__btn">
                    {' '}
                    {routeObject.key && (
                        <>
                            {routeObject.key.toLowerCase() === 'subscribed' && (
                                <>
                                    <Tooltip
                                        title="Sign up"
                                        placement="bottom"
                                        arrow={true}
                                    >
                                        <Button
                                            name="manage"
                                            variant="outlined"
                                            color="primary"
                                            disabled={
                                                isSignup !== undefined &&
                                                isSignup !== null &&
                                                isSignup
                                                    ? disableManage
                                                    : true
                                            }
                                            startIcon={
                                                <FontAwesomeIcon
                                                    icon={['fal', 'cog']}
                                                ></FontAwesomeIcon>
                                            }
                                            onClick={() => handleClickEvent('managed')}
                                        >
                                            {isSignup && disableManage && (
                                                <CircularProgress size={24} />
                                            )}
                                            Manage
                                        </Button>
                                    </Tooltip>
                                    <Tooltip
                                        title="Launch Dashboard"
                                        placement="bottom"
                                        arrow={true}
                                    >
                                        <Button
                                            name="launch"
                                            variant="contained"
                                            color="primary"
                                            disabled={
                                                isLaunch !== undefined &&
                                                isLaunch !== null &&
                                                isLaunch
                                                    ? isLaunchBtnClicked
                                                    : true
                                            }
                                            startIcon={
                                                <FontAwesomeIcon
                                                    icon={['fal', 'rocket-launch']}
                                                ></FontAwesomeIcon>
                                            }
                                            onClick={() => handleClickEvent('launch')}
                                        >
                                            {isLaunch && isLaunchBtnClicked && (
                                                <CircularProgress size={24} />
                                            )}
                                            Launch
                                        </Button>
                                    </Tooltip>
                                </>
                            )}
                            {routeObject.key.toLowerCase() === 'available' && (
                                <Tooltip
                                    title="Launch Signup portal"
                                    placement="bottom"
                                    arrow={true}
                                >
                                    <Button
                                        name="enroll"
                                        variant="outlined"
                                        color="primary"
                                        disabled={isEnrollAccess ? isBtnClicked : true}
                                        startIcon={
                                            <FontAwesomeIcon
                                                icon={['fal', 'cog']}
                                            ></FontAwesomeIcon>
                                        }
                                        onClick={() => handleClickEvent('enroll')}
                                    >
                                        {isEnrollAccess && isBtnClicked && (
                                            <CircularProgress size={24} />
                                        )}
                                        Enroll
                                    </Button>
                                </Tooltip>
                            )}
                        </>
                    )}
                </Grid>
            </Grid>
            {open && (
                <Dialog
                    className="dialog-thank-you"
                    open={open}
                    disableBackdropClick={true}
                >
                    <DialogContent>
                        <Grid item className="dialog-thank-you__img">
                            {' '}
                        </Grid>
                        <DialogContentText>
                            <>
                                <Typography variant="h5" className="thankyou-msg__h5">
                                    Thank you for registering your interest in{' '}
                                    {clientObject.clientprogramname} Registry!{' '}
                                </Typography>
                                <Typography variant="body1" className="thankyou-msg__p">
                                    Your request has been successfuly logged. Once
                                    approved by the designated authority, You will be
                                    notified and only then be able to complete the{' '}
                                    {clientObject.clientprogramname} Registry enrolment
                                    process.
                                </Typography>
                            </>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="dialog-thank-you__btn-div">
                        <Button
                            variant="outlined"
                            onClick={() => closeDialog()}
                            color="primary"
                            className={`action-btn`}
                        >
                            CLOSE
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </Grid>
    )
}

export default Program
